/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import { useMemo } from "react";

import { useGetStaffManagersList } from "../apis";

const useStaffManagersList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    showDeletedOnly,
    setShowDeletedOnly,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      isDeleted: showDeletedOnly,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
    }),
    [page, debouncedSearch, showDeletedOnly, sorting]
  );

  const {
    staffManagersList,
    meta,
    isLoading,
    refetch: refetchStaffManagers
  } = useGetStaffManagersList(requestParams);

  return {
    staffManagersList,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    showDeletedOnly,
    setShowDeletedOnly,
    setSorting,
    setSearchValue,
    setPage,
    refetchStaffManagers
  };
};

export default useStaffManagersList;
